const PrazoSchema = () => ({
  title: 'AgSUS Prazo de edital',
  fieldsets: [
    {
      id: 'default',
      title: 'Prazo principal',
      fields: [
        'rotulo',
        'dataInicio',
        'horaInicio',
        'dataFim',
        'horaFim',
        'link',
        'textoBotao',
      ],
    },
    { id: 'cronograma', title: 'Cronograma', fields: ['etapas', 'nota'] },
  ],
  properties: {
    rotulo: {
      title: 'Rótulo',
      description: 'Ex.: Inscrições, Propostas, Contribuições',
      default: 'Inscrições',
    },
    dataInicio: { title: 'Abertura', widget: 'date', description: 'Opcional.' },
    horaInicio: {
      title: 'Hora da abertura',
      widget: 'time',
      description: 'Opcional. Horário de Brasília.',
    },
    dataFim: {
      title: 'Encerramento',
      widget: 'date',
      description: 'Sem esta data, o bloco não aparece.',
    },
    horaFim: {
      title: 'Hora do encerramento',
      widget: 'time',
      description:
        'Opcional. Sem hora, o prazo vai até o fim do dia (horário de Brasília).',
    },
    link: {
      title: 'Link do botão',
      description: 'O edital ou a página de inscrição. Sem link, sem botão.',
    },
    textoBotao: { title: 'Texto do botão', default: 'Ver o edital' },
    etapas: {
      title: 'Etapas',
      description:
        'Mais rápido: cole a tabela do cronograma no campo "Colar o cronograma", abaixo do bloco. Numa retificação, cole de novo.',
      widget: 'object_list',
      schema: {
        title: 'Etapa',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['nome', 'inicio', 'fim'],
          },
        ],
        properties: {
          nome: { title: 'Etapa' },
          inicio: { title: 'Data (ou início)', widget: 'date' },
          fim: {
            title: 'Fim',
            widget: 'date',
            description: 'Vazio: um dia só.',
          },
        },
        required: [],
      },
    },
    nota: {
      title: 'Nota sob o cronograma',
      widget: 'textarea',
      description:
        'Ex.: Datas atualizadas pela Retificação nº 1, de 25/10/2026.',
    },
  },
  required: [],
});

export default PrazoSchema;
